import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Pencil = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="M5 8.00002V11H8L13.9393 5.06068C14.5251 4.47489 14.5251 3.52514 13.9393 2.93936L13.0607 2.06068C12.4749 1.47489 11.5251 1.47489 10.9393 2.06068L5 8.00002ZM7.37868 9.50002L10.909 5.96969L10.0303 5.09101L6.5 8.62134V9.50002H7.37868ZM12.8787 4.00002L11.9697 4.90903L11.091 4.03035L12 3.12134L12.8787 4.00002Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      d="M3.5 3.00002H7V4.50002H3.5L3.5 12.5H11.5V9.00002H13V12.5C13 13.3284 12.3284 14 11.5 14H3.5C2.67157 14 2 13.3284 2 12.5V4.50002C2 3.67159 2.67157 3.00002 3.5 3.00002Z"
      fill="currentColor"
    />
  </Icon>
));

export default Pencil;
